import request from '@/utils/request'

//获取招聘城市
export function getProvince(data) {
  return request(
    {
      url: '/api/website/getProvince',
      method: 'post',
      data,
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}
//列表
export function getRecruitList(data) {
  return request(
    {
      url: '/api/website/getRecruitList',
      method: 'post',
      data,
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}
// 招聘详情
export function getRecruitDetails(data) {
  return request(
    {
      url: '/api/website/getRecruitDetails',
      method: 'post',
      data,
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}

//申请招聘
export function addRecruitApply(data) {
  return request(
    {
      url: '/api/website/addRecruitApply',
      method: 'post',
      data,
      loading: false
    },
    res => {
      if (res.code === 200 || res.code === 1) {
        return 'cancel'
      } else {
        return false
      }
    }
  )
}
